import React from 'react'
import {RouterNavigation, RouterHeader, RouterMain, RouterFooter} from 'Router'

require('moment/locale/de');

class App extends React.Component {
   render() {
      return (<div id="body-container">
         <RouterNavigation/>
         <RouterHeader/>
         <RouterMain/>
         <RouterFooter/>
      </div>);
   }
};

export default App



// WEBPACK FOOTER //
// ./src/App.js